import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';

export const SignupPage = () => <Navigate to={ROUTES.landing} replace />;
